import { createSelector } from 'reselect'
import { selectUserBlacklistedTagIds, selectUserTags, selectUserWhitelistedTagIds } from './userSelector'
import { tagToTagItem, tagsToTagItems, tagsToCountedTagItems } from '../components/item/tagsTransformers'

/** @return {Immutable.Map<string, TagRecord>} */
const selectTags = state => state.tags.tags

/** @return {Immutable.OrderedSet<TagRecord>} */
const selectTrendingTags = state => state.trending.get('tags')

/** @return {Immutable.OrderedSet<TagRecord>} */
const selectAllTags = state => state.tags.allTags.get('allTagsItems')

/** @return {boolean} */
export const selectTagsLoading = state => state.tags.loading

/** @return {boolean} */
export const selectTagsFailedToLoad = state => state.tags.failedToLoad

/** @return {boolean} */
export const selectAllTagsLoading = state => state.tags.allTags.get('loading')

/** @return {boolean} */
export const selectAllTagsFailedToLoad = state => state.tags.allTags.get('failedToLoad')

/** @return {?TagRecord} */
export const selectTagBySlug = (state, slug) => selectTags(state).get(slug)

/** @type {(state: object, slugs: Immutable.Set<string>) => Immutable.List<Immutable.Map<string,any>>} */
export const selectTagItemsBySlugs = createSelector(
  selectTags,
  selectUserTags,
  (state, slugs) => slugs,
  (tagsMap, userTags, slugs) => {
    const tagRecords = slugs.map(slug => tagsMap.get(slug)).filter(tag => tag != null)
    return tagsToTagItems(tagRecords, userTags).toList()
  }
)

/** @type {(state: object) => Immutable.List<Immutable.Map<string,any>>} */
export const selectWhitelistedTagItems = createSelector(
  selectTags,
  selectUserWhitelistedTagIds,
  selectUserTags,
  (tagsMap, tagIds, userTags) => {
    const tags = tagsMap.filter(tag => tagIds.includes(tag.id))
    return tagsToTagItems(tags, userTags).toList()
  }
)

/** @type {(state: object) => Immutable.List<Immutable.Map<string,any>>} */
export const selectBlacklistedTagItems = createSelector(
  selectTags,
  selectUserBlacklistedTagIds,
  selectUserTags,
  (tagsMap, tagIds, userTags) => {
    const tags = tagsMap.filter(tag => tagIds.includes(tag.id))
    return tagsToTagItems(tags, userTags).toList()
  }
)

/** @return {?Immutable.Map<string,any>} TagItem, null if no breaking news */
export const selectBreakingNewsTagItem = (state) => {
  const tag = state.trending.get('tags').find(tag => tag.get('breaking') === true)
  return tag ? tagToTagItem(tag, selectUserTags(state)) : null
}

/** @type {(state: object) => Immutable.List<Immutable.Map<string,any>>} */
export const selectTrendingTagItems = createSelector(
  selectTrendingTags,
  selectUserTags,
  (tags, userTags) => {
    return tagsToTagItems(tags, userTags).toList()
  }
)

/** @type {(state: object) => Immutable.List<Immutable.Map<string,any>>} */
export const selectAllTagsItems = createSelector(
  selectAllTags,
  selectUserTags,
  (tags, userTags) => {
    return tagsToCountedTagItems(tags, userTags).toList()
  }
)
